import React from 'react'
import PeopleOutlinedIcon from '@mui/icons-material/PeopleOutlined'
import SchoolIcon from '@mui/icons-material/SchoolOutlined'
import Box from '@mui/material/Box'

import * as url from '../../shared/url'
import { NavigationItem, isActive } from '../navigation'
import { useHistory } from 'react-router-dom'

const InternalNavigation: React.FC = () => {
    const history = useHistory()
    return (
        <Box
            data-testid='internal-navigation'
            display='flex'
            alignItems='stretch'
        >
            <NavigationItem
                to={url.users}
                icon={<PeopleOutlinedIcon />}
                isActive={isActive(history, url.users, true)}
            >
                USERS
            </NavigationItem>
            <NavigationItem
                to={url.roles}
                icon={<SchoolIcon />}
                isActive={isActive(history, url.roles)}
            >
                ROLES
            </NavigationItem>
        </Box>
    )
}

export default InternalNavigation
